var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdcnt"},[_c('div',{staticClass:"breadcrumb light"},_vm._l((_vm.items),function(item,index){return _c('a',{key:index,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }